import { DEFAULT_INITIAL_PAGINATION_DATA } from "@saleor/config";
import { UseNavigatorResult } from "@saleor/hooks/useNavigator";
import { Sort } from "@saleor/types";
import { getSortUrlVariables } from "@saleor/utils/sort";

type CreateUrl = (id: string, params: Sort) => string;

function createSortHandlerWithId<T extends string>(
  id: string,
  navigate: UseNavigatorResult,
  createUrl: CreateUrl,
  params: Sort<T>
) {
  return (field: T) =>
    navigate(
      createUrl(id, {
        ...params,
        ...getSortUrlVariables(field, params),
        ...DEFAULT_INITIAL_PAGINATION_DATA
      }),
      true
    );
}

export default createSortHandlerWithId;
